"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const black = '#1D1F21';
const white = '#FFF';
const offWhite = '#FBFCFC';
const blue = '#61C9D7';
const green = '#5CEBA0';
const red = '#FD7A7D';
const yellow = '#FCE969';
const hoverGreen = '#37DF87';
const colors = {
  blacks: {
    5: '#fbfbfc',
    10: '#E9EBEC',
    // subsection bg color
    20: '#D4D7D9',
    30: '#B3B9BD',
    40: '#939BA0',
    50: '#6F787E',
    60: '#565E62',
    70: '#393E42'
  },
  blues: {
    5: '#EFF9FB',
    10: '#DFF4F7',
    20: '#B0E4EB',
    30: blue,
    40: '#05AAC0',
    50: '#0185A2',
    60: '#016179'
  },
  greens: {
    5: '#EDFDF5',
    10: '#DAFBEB',
    20: '#ABF6CF',
    30: green,
    40: '#2ED27C',
    50: '#0FAE5C',
    60: '#0F8548'
  },
  reds: {
    5: '#FFEBEB',
    10: '#FED7D8',
    20: '#FFB8B9',
    30: red,
    40: '#EF5557',
    50: '#E13436',
    60: '#C30F11'
  },
  yellows: {
    5: '#FFFCEB',
    10: '#FFF9D6',
    20: '#FFF4AD',
    30: yellow,
    40: '#F0D738',
    50: '#E2C508',
    60: '#D3B200'
  },
  black,
  white,
  offWhite,
  blue,
  green,
  hoverGreen,
  red,
  yellow,
  pink: '#fb7578' // TEMPORARY: this is to make the app happy, since ui package is a blend between the two
};
colors.textColor = colors.black;
colors.inputBorderColor = '#E2EEF0'; // TODO: update this to a new color, looks good like this for now tho.
colors.inputBorderColorActive = black;
colors.borderWidth = 2;
colors.circleButton = {
  background: '#d2e8ec',
  backgroundHover: '#b2dfe6',
  backgroundDisabled: colors.blacks[15],
  color: 'white',
  colorHover: 'white',
  colorDisabled: colors.blacks[20],
  messageColor: '#b0ccd0',
  messageColorHover: '#91cad4',
  cta: {
    background: green,
    backgroundHover: colors.greens[40],
    backgroundDisabled: colors.blacks[20],
    color: black,
    colorHover: black,
    colorDisabled: colors.blacks[10]
  },
  toolbar: {
    color: colors.black,
    colorHover: colors.black,
    colorDisabled: colors.blacks[30]
  }
};
const textColors = {
  blue,
  green: colors.greens[60],
  red: colors.reds[40],
  yellow: colors.yellows[70],
  subtle: colors.blacks[30],
  subtleBlue: '#BBBFC5',
  link: colors.blues[40],
  linkHover: colors.blues[50]
};
colors.pdfFill = {
  black: colors.black,
  grey: textColors.subtle,
  white: '#FFFFFF',
  darkBlue: colors.blues[85],
  blue,
  green: textColors.green,
  yellow: colors.yellows[60],
  red: colors.reds[85]
};
const paddings = {
  5: 5,
  10: 10,
  15: 15,
  20: 20,
  30: 30,
  40: 40,
  60: 60,
  80: 80,
  90: 90,
  100: 100
};
const fontSizes = {
  20: 10,
  30: 12,
  40: 14,
  50: 16,
  60: 18
};
const fontWeights = {
  lightest: 100,
  light: 200,
  thinner: 300,
  thin: 400,
  normal: 500,
  bold: 600,
  black: 700
};
const fontStack = 'Barlow, -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif';
const fontFamilies = {
  body: fontStack,
  heading: fontStack,
  monospace: 'Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace'
};
const shadows = {
  30: '0 0 6px 0 rgba(0,0,0,0.05)',
  50: '0 2px 11px 0 rgba(0,0,0,0.06)',
  55: '0 1px 11px 0 rgba(0,0,0,0.08)',
  60: '0 2px 15px 0 rgba(0,0,0,0.08)'
};
const sizes = {
  appTopPadding: 30,
  appTitleHeight: 30,
  customLogoHeight: 30
};
const selectors = {
  dashboardScrollContainer: '#app-container',
  // This is specifically only used when `Affix`ing the Etch Free
  // CastConnectEditor component.
  unauthenticatedContainer: 'body'
};
const globalStyleTheme = {
  'input-border-width': '2px',
  'font-family-body': fontStack,
  'text-color': black,
  'font-weight-normal': fontWeights.normal,
  'component-padding': paddings[20],
  'input-border-color': colors.inputBorderColor,
  'font-weight-bold': fontWeights.bold,
  'link-color': textColors.link,
  'link-color-hover': textColors.linkHover
};
var _default = exports.default = {
  colors,
  textColor: colors.textColor,
  textColors,
  paddings,
  padding: paddings[20],
  fontSizes,
  fontWeights,
  fontFamilies,
  shadows,
  sizes,
  selectors,
  borderRadius: 2,
  borderWidth: 2,
  globalStyleTheme
};